import { render, staticRenderFns } from "./NewLocale.vue?vue&type=template&id=1f8dd675&"
import script from "./NewLocale.vue?vue&type=script&lang=ts&"
export * from "./NewLocale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports